/**
 * EmailApp — root Preact component for the full CSR email UI.
 *
 * Renders the full 3-pane layout (sidebar | list | reading pane) entirely
 * client-side from JSON API data. Mounted into #email-app-root by email_controller.js.
 *
 * Props:
 *   store     {object}  — emailStore instance
 *   mailboxes {array}   — bootstrapped mailbox data from data attr
 *   i18n      {object}  — i18n-js instance
 */

import { h, createContext } from 'preact'
import { useContext } from 'preact/hooks'
import { EmailSidebar } from './EmailSidebar.jsx'
import { EmailList } from './EmailList.jsx'
import { EmailThread } from './EmailThread.jsx'
import { EmailCompose } from './EmailCompose.jsx'

export const EmailStoreContext = createContext(null)

export function useEmailStore() {
  return useContext(EmailStoreContext)
}

export function EmailApp({ store, i18n }) {
  const mailboxes = store.mailboxes.value

  return (
    <EmailStoreContext.Provider value={store}>
      <div class="email-layout">

        {/* Sidebar */}
        <div class="email-sidebar">
          <EmailSidebar store={store} i18n={i18n} />
        </div>

        {/* List pane */}
        <div class="email-list-pane" data-email-list-pane>
          <EmailList store={store} i18n={i18n} />
        </div>

        {/* Resizer handle */}
        <div class="email-resizer" data-email-resizer />

        {/* Reading pane */}
        <div class="email-reading-pane-wrapper">
          {store.isComposing.value
            ? <EmailCompose store={store} i18n={i18n} mailboxes={mailboxes} />
            : <EmailThread store={store} i18n={i18n} />
          }
        </div>

      </div>

      {/* Thread modal (kept outside grid to avoid layout interference) */}
      <div class="modal fade" id="email_thread_modal_container" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-body p-0" id="email_thread_modal">
              {/* Populated on demand via fetch when row is double-clicked */}
            </div>
          </div>
        </div>
      </div>
    </EmailStoreContext.Provider>
  )
}
